<template>
  <path
    fill-rule="evenodd"
    d="M74.864 1.444C66.12 1.227 25.087-4.128 12.22 9.37-.61 22.826-3.748 50.184 7.922 60.667 19.592 71.15 57.92 68.7 68.21 68.955c6.72.167 43.363-1.366 56.434-11.219 9.18-6.92 11.848-21.03 4.523-36.42C121.75 2.395 80.781 1.59 74.864 1.443z"
  />
</template>

<script>
export default {}
</script>



// WEBPACK FOOTER //
// components/_SVG/ShapeYearBtn4Mob.vue